export default __webpack_public_path__ + "static/media/dashboardworkspace.dbcd385f.svg";